import { FC, useEffect } from 'react';

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SizeMeTrigger = any; // В качестве триггера может быть все, что угодно, поэтому any

type SizeMeContentProps = {
  trigger: SizeMeTrigger;
  onTrigger: (triggerData: SizeMeContentProps['trigger']) => void;
  children: JSX.Element;
};

const SizeMeContent: FC<SizeMeContentProps> = ({
  trigger,
  onTrigger,
  children,
}) => {
  useEffect(() => {
    onTrigger(trigger);
  }, [trigger]);

  return children;
};

export default SizeMeContent;
